(function () {
  'use strict';

  // Every store Continue (button.store-cta) shows one visible transition before the
  // step changes. Instant steps are held for TRANSITION_MS with the pending state,
  // then the original click is replayed once. Buttons marked
  // data-store-cta-async="true" run a real check or save: they are not delayed and
  // show aria-busy for as long as the operation actually takes.
  var TRANSITION_MS = 650;
  var replaying = new WeakSet();
  var pending = null;

  function release() {
    document.documentElement.classList.remove('store-cta-transitioning');
    pending = null;
  }

  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest && event.target.closest('.store-cta');
    if (!button || replaying.has(button)) return;
    if (button.disabled || button.getAttribute('aria-busy') === 'true' ||
        button.getAttribute('data-store-cta-async') === 'true') return;

    event.preventDefault();
    event.stopImmediatePropagation();
    if (pending) return;
    pending = button;
    button.setAttribute('data-store-cta-pending', 'true');
    // While one step is moving, the rest of the page ignores taps (no double actions).
    document.documentElement.classList.add('store-cta-transitioning');

    window.setTimeout(function () {
      button.removeAttribute('data-store-cta-pending');
      release();
      if (!button.isConnected || button.disabled) return;
      replaying.add(button);
      try { button.click(); } finally { replaying.delete(button); }
    }, TRANSITION_MS);
  }, true);
})();
